import axios from "axios";
import { serverUrl } from "../../serverUrl";
import { setBusy } from "./uiActions";

// Independent Imports (PO) flow; initially mirrors the Imports (R) API contract.
export const setShopImportPO = (imports) => ({
  type: "SET_CURRENT_SHOP_IMPORT_PO",
  payload: imports,
});

export const getShopImportPO = (
  token_company_id,
  token_user_id,
  token_shop_id,
  journal_entry_id = null
) => {
  return async (dispatch, getState) => {
    try {
      const requestData = {
        token_company_id,
        token_user_id,
        token_shop_id,
        xoption: "POIMPORT_GET_LIST",
      };

      if (journal_entry_id != null && journal_entry_id !== "") {
        requestData.journal_entry_id = journal_entry_id;
      }

      const config = {
        method: "post",
        url: `${serverUrl}/api/admin/retailr/report`,
        headers: { "Content-Type": "application/json" },
        data: requestData,
      };

      const resp = await axios(config);

      dispatch(setBusy(true));

      if (journal_entry_id != null && journal_entry_id !== "" && !Array.isArray(resp.data)) {
        const currentImports = getState().database.currentShop?.importsPO;
        const currentList = Array.isArray(currentImports)
          ? currentImports
          : Object.values(currentImports || {});
        const responseItem = Array.isArray(resp.data?.data)
          ? resp.data.data[0]
          : resp.data;
        const nextList = currentList.map((item) => {
          const itemId = item?.journalentry_id ?? item?.journal_entry_id;
          const responseId =
            responseItem?.journalentry_id ??
            responseItem?.journal_entry_id ??
            journal_entry_id;
          return String(itemId) === String(responseId)
            ? { ...item, ...responseItem }
            : item;
        });
        dispatch(setShopImportPO(nextList));
      } else {
        dispatch(setShopImportPO(resp.data));
      }

      return resp.data;
    } catch (err) {
      console.log(err);
      return [];
    }
  };
};


